import React from 'react';
import Socials from "../../components/socials/socials";
import ProjectCard from '../Portfolio/ProjectCard';
import { project_list as projects } from "../Portfolio/project_list";

import { useNavigate } from "react-router-dom";

const title =
    " ______  ______  ______  ______  ______  ______  __      __  ______   \n" +
    "/\\  == \\/\\  __ \\/\\  == \\/\\__  _\\/\\  ___\\/\\  __ \\/\\ \\    /\\ \\/\\  __ \\  \n" +
    "\\ \\  _-/\\ \\ \\/\\ \\ \\  __<\\/_/\\ \\/\\ \\  __\\\\ \\ \\/\\ \\ \\ \\___\\ \\ \\ \\/\\ \\ \n" +
    " \\ \\_\\   \\ \\_____\\ \\_\\ \\_\\ \\ \\_\\ \\ \\_\\   \\ \\_____\\ \\_____\\ \\_\\ \\_____\\\n" +
    "  \\/_/    \\/_____/\\/_/ /_/  \\/_/  \\/_/    \\/_____/\\/_____/\\/_/\\/_____/"

let windowWidth = window.innerWidth

const featuredProjects = projects.filter((project) => project.id >= 6)
const Home: React.FC = () => {
    const navigate = useNavigate()

    const handleClick = (id: number) => {
        return navigate(`/project/${id}`)
    }
    return (
        <>
            <div style={{ overflowX: "hidden", width: "100%", maxWidth: "100vw" }}>
                {/* {window && <DraggableWindow
                    height={300}
                    width={windowWidth < 765 ? 310 : 600}
                    x={windowWidth < 765 ? 75 : windowWidth / 2.5}
                    y={200}
                    title={"AboutMe.tsx"}
                    onclick={() => {
                        setWindow(false)
                    }}>
                    <h1 style={{ color: "black" }}>Awsaf Fida Mahmud</h1>
                    <h2 style={{ color: "black" }}>Software Developer</h2>
                    <Socials
                        style=
                        {{
                            color: "black",
                            display: 'flex',
                            gap: '10px',
                            alignItems: 'center',
                            justifyContent: "center"
                        }} />
                    <h3 style={{ color: "black" }}>I’m Awsaf Fida, software engineer recently graduated from George Brown
                        College with an advanced diploma in Programming and Analysis. My real selling point i...</h3>
                    <Link to={"/about"} style={{ color: "blue" }}>Learn more</Link>
                    <img
                        src={"https://github-readme-streak-stats.herokuapp.com?user=omelettech&theme=dark&background=000000"}
                        alt={"Github details"}
                        style={{ width: "100%", marginTop: "1rem" }}
                    />


                </DraggableWindow>} */}

                {/* {windowWidth > 765 && <DraggableWindow height={300} width={280} x={300} y={500}>
                <Minesweeper></Minesweeper>
            </DraggableWindow>} */}

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "65vh",
                    textAlign: "center",
                    padding: "2rem"
                }}>
                    <h1 style={{ fontSize: windowWidth < 765 ? "2.5rem" : "5rem", marginBottom: "0.5rem" }}>Awsaf Fida Mahmud</h1>
                    <h2 style={{ fontSize: windowWidth < 765 ? "1.5rem" : "2.5rem", color: "var(--text-300)", marginBottom: "1.5rem" }}>Software Developer</h2>
                    <h3>Currently working on <a target='_blank' href='https://www.huskyhack.ca' style={{ color: "var(--secondary-700)", }}>
                        HuskyHack.ca
                    </a>
                    </h3>
                    <Socials style={{ display: 'flex', gap: '20px', justifyContent: 'center', color: "var(--text-50)" }} />
                </div>

                {/* {consoleWindow && (
                    <DraggableWindow
                        height={400}
                        width={windowWidth < 765 ? windowWidth - 20 : 650}
                        x={windowWidth < 765 ? 10 : windowWidth - 670}
                        y={windowWidth < 765 ? 60 : 80}
                        title={"Console.exe"}
                        onclick={() => setConsoleWindow(false)}
                    >
                        <Console />
                    </DraggableWindow>
                )} */}


            </div>
            <div style={{ overflow: "hidden", width: "100%", maxWidth: "100vw", flexDirection: "column", display: "flex", alignItems: "center" }}>
                <pre className={"ascii-title"}>
                    {title}
                </pre>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {featuredProjects.map((project, id) => {
                        return <ProjectCard project={project} key={id} onClick={() => handleClick(project.id)}></ProjectCard>
                    })}
                </div>
            </div>
        </>
    );
};

export default Home;
